import i18next from 'i18next';
import ar from './navigation-i18n/ar';
import en from './navigation-i18n/en';
import tr from './navigation-i18n/tr';
import { authRoles } from '../auth';

i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('tr', 'navigation', tr);
i18next.addResourceBundle('ar', 'navigation', ar);

const navigationConfig = [
  {
    id: 'dashboard',
    title: 'داشبورد',
    type: 'item',
    icon: 'material-outline:supervised_user_circle',
    auth: authRoles[1],
    url: 'dashboard',
  },
  {
    id: 'managers',
    title: 'مدیران',
    type: 'item',
    icon: 'material-outline:store',
    url: 'managers',
  },
  {
    id: 'drivers',
    title: 'سفیرها',
    type: 'collapse',
    icon: 'material-outline:list',
    children: [
      {
        id: 'drivers.new-vehicle',
        title: 'ایجاد و تعریف وسیله نقلیه',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'drivers/new-vehicle',
      },
      {
        id: 'drivers.InProgress',
        title: 'تایید و رد سفیرها',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'drivers/list',
      },
      {
        id: 'drivers.history',
        title: 'سوابق سفیرها',
        type: 'item',
        icon: 'material-outline:inventory',
        url: 'drivers/history',
      },
    ],
  },
  {
    id: 'tariff',
    title: 'مدیریت تعرفه',
    type: 'collapse',
    icon: 'material-outline:list',
    children: [
      {
        id: 'tariff.transportList',
        title: 'تعریف وسیله نقلیه',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'tariff/transport-list',
      },
      {
        id: 'tariff.baseTariff',
        title: 'تعرفه حقوق پایه و نرخ',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'tariff/base-tariff',
      },
    ],
  },
  {
    id: 'trips',
    title: 'سفرها',
    type: 'collapse',
    icon: 'material-outline:list',
    children: [
      {
        id: 'trips.assignTrips',
        title: 'تخصیص سفیر',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'trips/assign-trips',
      },
      {
        id: 'trips.currentTrips',
        title: 'سفرهای در حال انجام',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'trips/current-trips',
      },
      {
        id: 'trips.pendingTrips',
        title: 'سفرهای معلق',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'trips/pending-trips',
      },
      {
        id: 'trips.archiveTrips',
        title: 'ارشیو سفرها',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'trips/archive-trips',
      },
    ],
  },
  {
    id: 'communications',
    title: 'ارتباطات',
    type: 'collapse',
    icon: 'material-outline:list',
    children: [
      {
        id: 'communications.voip',
        title: 'گزارش voip',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'communications/voip',
      },
      {
        id: 'communications.tickets',
        title: 'تیکت ها',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'communications/tickets',
      },
      {
        id: 'communications.notifications',
        title: 'اعلان ها',
        type: 'item',
        icon: 'material-outline:view_in_ar',
        url: 'communications/notifications',
      },
    ],
  },
];

export default navigationConfig;
